// ReactRenderers.tsx
import React from "react";
import {createRoot, Root} from "react-dom/client";
import { ReactFormBuilder } from "react-form-builder2";
import "react-form-builder2/dist/app.css";

// Render FormBuilder
export function renderReactFormBuilder(elementId: string): void {
  const element: HTMLElement | null = document.getElementById(elementId);
  if (!element) return;

  const root: Root = createRoot(element);
  root.render(<ReactFormBuilder saveUrl="saveUrl" />);
}
